const EnumExpressions: any = Object.freeze({
  1: "DISAGREE",
  2: "NOT CLEAR",
  3: "AGREE",
  4: "OFF POINT",
  5: "WRAP UP",
});

export default EnumExpressions;
